import React from "react";
import PropTypes from "prop-types";
import StudentListItem from "../StudentListItem/StudentListItem";
import styles from "./StudentList.module.css";

const StudentList = ({
  students,
  onCheckboxChange,
  onStatusChange,
  onWatchReportSubmitClick,
  onStudentNameClick,
  view,
}) => {
  return (
    <div className="scroll-wrapper">
      <div className={styles.container}>
        {students.length === 0 ? (
          <div className={styles.no_data_row}>
            No data available in table
          </div>
        ) : (
          students.map((student, index) => (
            <React.Fragment key={index}>
              <StudentListItem
                student={student}
                onCheckboxChange={onCheckboxChange}
                onStatusChange={onStatusChange}
                onWatchReportSubmitClick={onWatchReportSubmitClick}
                onStudentNameClick={onStudentNameClick}
                view={view}
              />
              {/* {index < students.length - 1 && <div className={styles.divider} />} */}
            </React.Fragment>
          ))
        )}
      </div>
    </div>
  );
};

StudentList.propTypes = {
  students: PropTypes.arrayOf(PropTypes.object),
  onCheckboxChange: PropTypes.func,
  onStatusChange: PropTypes.func,
  onWatchReportSubmitClick: PropTypes.func,
  onStudentNameClick: PropTypes.func,
  view: PropTypes.oneOf(["background", "cpnw"]),
};

export default StudentList;
